import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-77febdf7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "bg-banner",
  id: "form"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "d-flex justify-content-center banner-content-wrap" }
const _hoisted_4 = { class: "banner-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-header" }, "Reservieren Sie Ihr Wunschkennzeichen jetzt online!", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-subheader" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Schritt 1:"),
  /*#__PURE__*/_createTextVNode(" Zulassungsstelle auswählen")
], -1))
const _hoisted_7 = ["onKeydown"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "code-part-2" }, "AB", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "code-part-3" }, "123", -1))
const _hoisted_10 = { class: "banner-license-cta" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Zur Reservierung ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Zustellungsstelle wird gesucht...", -1))
const _hoisted_14 = {
  key: 0,
  class: "office-select-overlay"
}
const _hoisted_15 = { class: "office-select-box" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Zulassungsstelle auswählen", -1))
const _hoisted_17 = { class: "content" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Für Ihr eingegebenes Kennzeichen kommen mehrere Zulassungsstellen in Frage. Bitte wählen Sie die gewünscht Zuslassungsstelle aus. ", -1))
const _hoisted_19 = { class: "office-list" }
const _hoisted_20 = ["href"]

import { Axios } from 'axios';
import LoadingAnimation from '@/assets/animations/home-animation-1.json';
import { ILicenseOffice } from '../classes/interfaces/data';
import { ref, inject, computed, onMounted, onUnmounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const AxiosClient = inject('axios') as Axios;

const InputValue = ref<string>('');
const LoadingActive = ref<boolean>(false);
const Offices = ref<ILicenseOffice[]>([]);

const Scale = ref<number>(1);
const Height = ref<number>(0);
const WrapElement = ref<HTMLElement>();
const LicenseElement = ref<HTMLElement>();

const InputValid = computed(() => {
  const reg = new RegExp(/^[A-Za-z]+$/);

  return (
    typeof InputValue.value === 'string' &&
    InputValue.value.length > 0 &&
    InputValue.value.length <= 3 &&
    reg.test(InputValue.value)
  );
});

const ValidateInput = () => {
  InputValue.value = InputValue.value.replace(/[^a-zA-Z ]/g, '');
};

const CheckForOffices = async (): Promise<void> => {
  if (!InputValid.value) {
    return;
  }

  LoadingActive.value = true;

  const Promises: Promise<any>[] = [];

  Promises.push(
    AxiosClient.post('/GetOfficesForCode', {
      code: InputValue.value,
    }),
  );
  Promises.push(
    new Promise((resolve) => {
      setTimeout(resolve, 800);
    }),
  );

  const [OfficeResponse] = await Promise.all(Promises);

  if (Array.isArray(OfficeResponse.data)) {
    Offices.value = OfficeResponse.data as ILicenseOffice[];

    if (Offices.value.length == 0) {
      // not yet supported
      window.location.href = `https://www.wunschkennzeichen.de/kennzeichen-und-autokennzeichen-fuer-kfz-wkz?wkz=${InputValue.value}`;
    } else if (Offices.value.length == 1) {
      // only 1 office
      window.location.href = `/kennzeichen/${InputValue.value.toUpperCase()}/${
        Offices.value[0].Slug
      }`;
    }
  }

  LoadingActive.value = false;
};

const SetSize = () => {
  if (typeof WrapElement.value === 'undefined' || typeof LicenseElement.value === 'undefined') {
    return;
  }

  Scale.value = WrapElement.value.clientWidth / LicenseElement.value?.clientWidth;
  console.log(WrapElement.value.clientWidth, Scale.value);
  Height.value = LicenseElement.value?.clientHeight * Scale.value;
};

onMounted(() => {
  window.addEventListener('resize', SetSize);
  SetSize();
});

onUnmounted(() => {
  window.removeEventListener('resize', SetSize);
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Vue3Lottie = _resolveComponent("Vue3Lottie")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("div", {
              class: "banner-license-input-wrap",
              ref: (_value, _refs) => {
                _refs['WrapElement'] = _value
                WrapElement.value = _value
              },
              style: _normalizeStyle({ height: `${Height.value}px` })
            }, [
              _createElementVNode("div", {
                class: "banner-license-input",
                ref: (_value, _refs) => {
                  _refs['LicenseElement'] = _value
                  LicenseElement.value = _value
                },
                style: _normalizeStyle({ transform: `scale(${Scale.value})` })
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "AB",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((InputValue).value = $event)),
                  maxlength: "3",
                  onKeydown: _withKeys(CheckForOffices, ["enter"]),
                  onKeyup: ValidateInput,
                  class: _normalizeClass(`length-${InputValue.value.length}`)
                }, null, 42, _hoisted_7), [
                  [_vModelText, InputValue.value]
                ]),
                _hoisted_8,
                _hoisted_9
              ], 4)
            ], 4),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("button", {
                class: "call-to-action-button",
                disabled: !_unref(InputValid),
                onClick: CheckForOffices
              }, [
                _hoisted_12,
                _createVNode(_component_font_awesome_icon, {
                  style: { color: '#fff' },
                  icon: ['fas', 'arrow-right']
                })
              ], 8, _hoisted_11)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["banner-loading", { hidden: !LoadingActive.value }])
            }, [
              _createVNode(_component_Vue3Lottie, {
                animationData: _unref(LoadingAnimation),
                height: 150,
                width: 200
              }, null, 8, ["animationData"]),
              _hoisted_13
            ], 2)
          ])
        ])
      ])
    ]),
    (Offices.value.length > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Offices.value, (Office) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: Office.id,
                    href: `/kennzeichen/${InputValue.value.toUpperCase()}/${Office.Slug}`
                  }, [
                    _createElementVNode("button", null, _toDisplayString(Office.Name), 1)
                  ], 8, _hoisted_20))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})